import MigrationManagement from '@/views/Admin/MigrationManagement.vue';
import TenantManagement from '@/views/Admin/TenantManagement.vue';

const AdminRoutes = [
    {
        path: "/admin/migrations",
        name: "Admin - Migrations",
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        components: {
            page: MigrationManagement
        }
    },
    {
        path: "/admin/tenants",
        name: "Admin - Tenants",
        meta: {
            requiresAuth: true,
            requiresAdmin: true
        },
        components: {
            page: TenantManagement
        }
    }
    // TODO: Add routes for Email Management, Subscription Management, Admin User Management
];

export default AdminRoutes;
